import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'tmwDurationFormat',
  pure: false,
  standalone: true,
})
export class TmwDurationFormatPipe implements PipeTransform {
  transform(value: any, arg1: any, arg2: any): any {
    let days: any;
    let seconds: any;
    let minutes: any;
    let hours: any;

    if (arg1 === 'ms' && arg2 === 'hhmmss') {
      seconds = Math.floor((value / 1000) % 60);
      minutes = Math.floor((value / (1000 * 60)) % 60);
      hours = Math.floor(value / (1000 * 60 * 60));
      return this.format(arg2, seconds, minutes, hours, days);
    } else if (arg1 === 's' && arg2 === 'hhmmss') {
      seconds = Math.floor(value % 60);
      minutes = Math.floor((value / 60) % 60);
      hours = Math.floor(value / 60 / 60);
      return this.format(arg2, seconds, minutes, hours, days);
    } else if (arg1 === 'ms' && (arg2 === 'ddhhmmss' || arg2 === 'ddhhmmssLong' || arg2 === 'ddhhmmLong')) {
      seconds = Math.floor((value / 1000) % 60);
      minutes = Math.floor((value / (1000 * 60)) % 60);
      hours = Math.floor((value / (1000 * 60 * 60)) % 24);
      days = Math.floor(value / (1000 * 60 * 60 * 24));
      return this.format(arg2, seconds, minutes, hours, days);
    } else if (arg1 === 's' && (arg2 === 'ddhhmmss' || arg2 === 'ddhhmmssLong' || arg2 === 'ddhhmmLong')) {
      seconds = Math.floor(value % 60);
      minutes = Math.floor((value / 60) % 60);
      hours = Math.floor((value / 60 / 60) % 24);
      days = Math.floor(value / 60 / 60 / 24);
      return this.format(arg2, seconds, minutes, hours, days);
    } else if (arg1 === 'ms' && arg2 === 'smart') {
      seconds = Math.floor((value / 1000) % 60);
      minutes = Math.floor((value / (1000 * 60)) % 60);
      hours = Math.floor((value / (1000 * 60 * 60)) % 24);
      days = Math.floor(value / (1000 * 60 * 60 * 24));
      return this.formatSmart(seconds, minutes, hours, days);
    } else if (arg1 === 's' && arg2 === 'smart') {
      seconds = Math.floor(value % 60);
      minutes = Math.floor((value / 60) % 60);
      hours = Math.floor((value / 60 / 60) % 24);
      days = Math.floor(value / 60 / 60 / 24);
      return this.formatSmart(seconds, minutes, hours, days);
    } else {
      return value;
    }
  }

  private format(fmt: string, seconds: any, minutes: any, hours: any, days: any): string {
    if (days) {
      days < 10 ? (days = '0' + days) : days;
    }
    if (hours) {
      hours < 10 ? (hours = '0' + hours) : hours;
    }
    minutes < 10 ? (minutes = '0' + minutes) : minutes;
    seconds < 10 ? (seconds = '0' + seconds) : seconds;

    switch (fmt) {
      case 'hhmmss':
        return `${hours}:${minutes}:${seconds}`;

      case 'ddhhmmss':
        return `${days}j, ${hours}h, ${minutes}m, ${seconds}s`;

      case 'ddhhmmLong': {
        let result: string[] = [];
        if (days) {
          result.push(`${days} jours`);
        }
        if (hours) {
          result.push(`${hours} heures`);
        }
        result.push(`${minutes} minutes`);
        return result.join(', ');
      }

      case 'ddhhmmssLong': {
        let result: string[] = [];
        if (days) {
          result.push(`${days} jours`);
        }
        if (hours) {
          result.push(`${hours} heures`);
        }
        result.push(`${minutes} minutes`);
        result.push(`${seconds} secondes`);
        return result.join(', ');
      }
    }
    return `${hours}:${minutes}:${seconds}`;
  }

  private formatSmart(seconds: number, minutes: number, hours: number, days: number): string {
    if (days > 0) {
      return hours > 0 ? `${days}j ${hours}h` : `${days}j`;
    }
    if (hours > 0) {
      return minutes > 0 ? `${hours}h ${minutes} min` : `${hours}h`;
    }
    if (minutes > 0) {
      return seconds > 0 ? `${minutes} min ${seconds}s` : `${minutes} min`;
    }
    return `${seconds}s`;
  }
}
